import { render, staticRenderFns } from "./CoverageList.vue?vue&type=template&id=cf03a372&"
import script from "./CoverageList.vue?vue&type=script&lang=js&"
export * from "./CoverageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf03a372')) {
      api.createRecord('cf03a372', component.options)
    } else {
      api.reload('cf03a372', component.options)
    }
    module.hot.accept("./CoverageList.vue?vue&type=template&id=cf03a372&", function () {
      api.rerender('cf03a372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/CoverageList.vue"
export default component.exports